import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';
import { NavigationResponse, NavigationItem } from '../types';

export default function useNavigation() {
  const [navigation, setNavigation] = useState<NavigationItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchNavigation = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(`${API_BASE_URL}/api/v2/navigation/`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: NavigationResponse = await response.json();
      setNavigation(data.navigation);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch navigation');
      console.error('Error fetching navigation:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNavigation();
  }, []);

  return { navigation, loading, error, refetch: fetchNavigation };
}
